import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {DatePipe} from "@angular/common";

@Component({ standalone: false,
    selector: 'irb-mmc-performance-model',
    templateUrl: './mmc-performance-model.component.html',
    styleUrls: ['./mmc-performance-model.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MmcPerformanceModelComponent implements OnInit, AfterViewInit {

    @Input() data: any;
    @Output() change = new EventEmitter<boolean>();
    @Output() validChange = new EventEmitter<any>();
    @Input() eventModelType: string;

    @ViewChild('meTxt') meTxt: any;
    @ViewChild('t3Txt') t3Txt: any;
    @ViewChild('yrdTxt') yrdTxt: any;
    @ViewChild('t12Txt') t12Txt: any;
    @ViewChild('yr3Txt') yr3Txt: any;
    @ViewChild('yr5Txt') yr5Txt: any;
    @ViewChild('yr10Txt') yr10Txt: any;
    @ViewChild('rorInceptionTxt') rorInceptionTxt: any;
    @ViewChild('IrbDropdownAsOfDate') IrbDropdownAsOfDate: any;

    performanceAsOfDate: any;
    selectedPerformanceAsOfDate: any;
    inceptionDate: Date;
    currentDate: Date;
    inceptionDateIsValid: boolean = true;
    asOfDateRequired = false;
    toolTipShow = false;
    private isProcessing = false;
    disableFields = true;

    constructor(private util: UtilityService, private datePipe: DatePipe) {}

    ngOnInit(): void {
        if (this.data) {
            if (this.data.performanceAsOf) {
                let d = this.util.getEasternTime(this.data.performanceAsOf);
                d = this.datePipe.transform(d, 'MM/dd/yyyy');
                this.performanceAsOfDate = {value: d, name: d};
                this.selectedPerformanceAsOfDate = {value: d, name: d};
            }

            if (this.data.inceptionDate) {
                this.inceptionDate = new Date(this.data.inceptionDate);
            }
            this.isProcessing = this.data.updateStatus === "PROCESSING";
            this.disableFields = this.isProcessing || this.data.usedFor !== 'custom';
        }

        this.currentDate = new Date();
    }

    ngAfterViewInit() {
        this.validateEntries();
    }


    validateEntries() {
        let isValid: boolean = true;

        if (this.meTxt && this.meTxt.inputControl && !this.meTxt.inputControl.disabled) {
            if (!this.meTxt.inputControl.valid
                || !this.t3Txt.inputControl.valid
                || !this.yrdTxt.inputControl.valid
                || !this.t12Txt.inputControl.valid
                || !this.yr3Txt.inputControl.valid
                || !this.yr5Txt.inputControl.valid
                || !this.yr10Txt.inputControl.valid
                || !this.rorInceptionTxt.inputControl.valid
                || !this.inceptionDateIsValid
            ) {
                isValid = false;
            }
        }

        if (isValid) {
            this.asOfDateRequired = false;
            this.toolTipShow = false;
            if (!this.nullOrBlank(this.data.me)
                || !this.nullOrBlank(this.data.t3)
                || !this.nullOrBlank(this.data.ytd)
                || !this.nullOrBlank(this.data.t12)
                || !this.nullOrBlank(this.data.yr3)
                || !this.nullOrBlank(this.data.yr5)
                || !this.nullOrBlank(this.data.yr10)
            ) {
                this.asOfDateRequired = true;
                if (!this.data.performanceAsOf) {
                    isValid = false;
                    this.toolTipShow = true;
                }
            }
        }

        if(isValid && !this.data.inceptionDate) {
            isValid = false;
        }

        this.change.emit();
        this.validChange.emit({type: 'performance', valid: isValid});
    }

    private nullOrBlank(v: any) {
        return v === null || v === '';
    }

    performanceAsOfChange(e: any) {
        if (e.value) {
            this.data.performanceAsOf = this.formatDateAsString(new Date(e.value));
        } else {
            this.selectedPerformanceAsOfDate = this.selectedPerformanceAsOfDate === null ? -1 : null;
            this.data.performanceAsOf = null;
        }
        this.change.emit(true);
        this.validateEntries();
    }
    formatDateAsString(d: Date):String {
        let mon: any = d.getMonth() + 1;

        if (mon < 10) {
            mon = '0' + mon;
        }

        let dd: any = d.getDate();

        if (dd < 10) {
            dd = '0' + dd;
        }

        return d.getFullYear() + '-' + mon + '-' + dd;
    }

    inceptionDateChange() {
        setTimeout(() => {
            this.inceptionDateIsValid = true;

            if(this.inceptionDate) {
              this.data.inceptionDate = this.inceptionDate.setHours(0, 0, 0);
              let isLastDayOfMonth = this.inceptionDateFilter(new Date(this.data.inceptionDate));
              this.inceptionDateIsValid = this.data.inceptionDate <= this.currentDate.getTime() && isLastDayOfMonth;
            } else {
              this.data.inceptionDate = null;
            }

            this.change.emit(true);
            this.validateEntries();
        }); 
    }

    getAsOfDateLists(searchStr: any) {
        let ddList: Array<any> = [];
        const r: Array<any> = this.getPerformanceAsOfDates();
        r.forEach((d: any) => {
            ddList.push({name: d, value: d});
        });
        if (this.data.performanceAsOf) {
            ddList.push({name: '- deselect date -', value: null});
        }
        this.IrbDropdownAsOfDate.set(DropdownFilterComponent.getFilteredList(searchStr, ddList));
    }

    private getPerformanceAsOfDates() {
        let r: Array<any> = [];
        const now = new Date();
        let year = now.getFullYear();
        let m = (now.getMonth() + 1);

        for (let i = 0; i < 12; i++) {
            if (m <= 0) {
                year--;
                m = 12;
            }

            let d = new Date(year, m, 0);
            r.push(this.formatDate(d));

            m--;
        }
        if (this.performanceAsOfDate && this.performanceAsOfDate.value && r.indexOf(this.performanceAsOfDate.value) === -1) {
            r.push(this.performanceAsOfDate.value);
        }
        return r;
    }

    private formatDate(d: Date) {
        const year: any = d.getFullYear();
        let month: any = d.getMonth() + 1;
        let day: any = d.getDate();
        month = month < 10 ? '0' + month : month;
        return month + '/' + day + '/' + year;
    }

    inceptionDateFilter(d: Date) {
        if(d) {
            let test = new Date(d.getTime());
            test.setDate(test.getDate() + 1);
            return test.getDate() === 1;
        }

        return true;
    }
}
